module.exports = __webpack_public_path__ + "img/small-1.2297801d.jpg";